var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3905_2713",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0902 12.2171H14.999V17.9842H23.0959C22.9657 18.8003 22.6735 19.6032 22.2455 20.3354C21.7551 21.1741 21.1489 21.8127 20.5275 22.299C18.6662 23.7558 16.4962 24.0537 14.9892 24.0537C11.1822 24.0537 7.92934 21.5406 6.6701 18.1257C6.61928 18.0018 6.58554 17.8738 6.54445 17.7473C6.26618 16.8781 6.11414 15.9577 6.11414 15.001C6.11414 14.0053 6.27878 13.0522 6.57898 12.152C7.76309 8.60177 11.0893 5.95008 14.9919 5.95008C15.7769 5.95008 16.5328 6.04551 17.2496 6.23586C18.8879 6.67088 20.0468 7.52765 20.7569 8.20535L25.0414 3.9197C22.4352 1.47896 19.0376 3.69022e-09 14.9848 3.69022e-09C11.7448 -7.12241e-05 8.75356 1.03098 6.30232 2.77348C4.31444 4.18661 2.68409 6.0786 1.58381 8.27594C0.560388 10.3133 0 12.5711 0 14.9987C0 17.4264 0.561244 19.7077 1.58467 21.7262V21.7398C2.66566 23.8828 4.24644 25.7279 6.1677 27.1345C7.84613 28.3634 10.8557 30 14.9848 30C17.3593 30 19.4638 29.5627 21.3197 28.7433C22.6586 28.1522 23.8448 27.3811 24.9188 26.3902C26.3379 25.0809 27.4493 23.4614 28.2079 21.5981C28.9665 19.7348 29.3723 17.6277 29.3723 15.3433C29.3723 14.2795 29.2677 13.199 29.0902 12.217V12.2171Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3905_2713)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3905_2713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.216309 15.1006C-0.200733 17.49 0.465863 19.9552 1.47487 21.9453V21.959C2.20392 23.4043 3.20033 24.5459 4.33522 25.6771L11.1897 23.1226C9.89285 22.4497 9.69497 22.0375 8.76536 21.2852C7.81538 20.3068 7.10735 19.1836 6.66642 17.8666H6.64866L6.66642 17.8529C6.37634 16.9832 6.34773 16.06 6.33702 15.1006H-0.216309Z",
    fill: "url(#paint0_radial_3905_2713)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3905_2713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.999 -0.108887C14.3215 2.3221 14.5805 4.68511 14.999 6.06001C15.7813 6.0606 16.535 6.15585 17.2496 6.34561C18.8879 6.78063 20.0466 7.63742 20.7567 8.31512L25.1509 3.91998C22.5478 1.48215 19.415 -0.105046 14.999 -0.108887Z",
    fill: "url(#paint1_radial_3905_2713)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_3905_2713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9844 -0.128174C11.6613 -0.128247 8.59324 0.929271 6.07907 2.71651C5.14556 3.38012 4.2889 4.14669 3.52609 4.99914C3.32625 6.91397 5.02202 9.26748 8.38016 9.248C10.0095 7.31219 12.4193 6.05973 15.1014 6.05973C15.1038 6.05973 15.1062 6.05994 15.1086 6.05995L14.9991 -0.127736C14.9942 -0.127739 14.9894 -0.128174 14.9844 -0.128174Z",
    fill: "url(#paint2_radial_3905_2713)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_3905_2713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9523 15.7936L22.9862 17.8748C22.8561 18.691 22.5636 19.4939 22.1356 20.226C21.6452 21.0648 21.039 21.7034 20.4177 22.1897C18.5602 23.6434 16.396 23.9428 14.8893 23.944C13.332 26.653 13.059 28.0099 14.9989 30.1963C17.3992 30.1945 19.5272 29.752 21.4042 28.9232C22.761 28.3241 23.9631 27.5428 25.0516 26.5386C26.4897 25.2117 27.6162 23.5704 28.385 21.6821C29.1537 19.7938 29.5648 17.6586 29.5648 15.3435L25.9523 15.7936Z",
    fill: "url(#paint3_radial_3905_2713)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_3905_2713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7797 11.9983V18.2035H29.0504C29.1759 17.3537 29.591 16.254 29.591 15.3436C29.591 14.2797 29.4864 12.9803 29.309 11.9983H14.7797Z",
    fill: "#3086FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_3905_2713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.59405 4.78003C2.7134 5.76417 1.96105 6.86571 1.36453 8.057C0.341125 10.0944 -0.219238 12.5713 -0.219238 14.9988C-0.219238 15.0331 -0.216466 15.0665 -0.216243 15.1007C0.236992 15.9883 6.04437 15.8183 6.33709 15.1007C6.33672 15.0672 6.33303 15.0346 6.33303 15.001C6.33303 14.0053 6.49772 13.2714 6.79792 12.3713C7.16825 11.2609 7.74811 10.2384 8.48958 9.35749C8.65766 9.13832 9.10601 8.66713 9.23681 8.38451C9.28664 8.27686 9.14635 8.21643 9.1385 8.17854C9.12973 8.13616 8.94164 8.17024 8.8995 8.13868C8.76571 8.03844 8.50077 7.9861 8.33988 7.93957C7.99601 7.84013 7.42613 7.62082 7.10959 7.39348C6.10904 6.67488 4.54759 5.81652 3.59405 4.78003Z",
    fill: "url(#paint4_radial_3905_2713)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_3905_2713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.13086 8.18269C9.45103 9.61818 10.1183 7.45812 11.6609 6.78219L8.97748 1.09863C7.99038 1.52238 7.05776 2.04884 6.19244 2.66396C4.90016 3.58261 3.75898 4.70361 2.81628 5.97933L7.13086 8.18269Z",
    fill: "url(#paint5_radial_3905_2713)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_3905_2713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.07522 22.6835C4.96069 23.832 4.47309 23.8731 4.1864 25.8446C4.73426 26.3906 5.32289 26.8957 5.9484 27.3537C7.62683 28.5825 10.8554 30.2192 14.9845 30.2192C14.9893 30.2192 14.994 30.2187 14.9988 30.2187V23.8344C14.9957 23.8344 14.9921 23.8346 14.989 23.8346C13.4428 23.8346 12.2072 23.4198 10.9404 22.6985C10.628 22.5207 10.0614 22.9982 9.77329 22.7847C9.37598 22.4903 8.41982 23.0384 8.07522 22.6835Z",
    fill: "url(#paint6_radial_3905_2713)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter8_f_3905_2713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1747 23.6333V30.1081C13.7524 30.1772 14.3537 30.2191 14.9844 30.2191C15.6167 30.2191 16.2283 30.186 16.8227 30.125V23.6769C16.1566 23.7932 15.5293 23.8346 14.9889 23.8346C14.3665 23.8346 13.7612 23.7606 13.1747 23.6333Z",
    fill: "url(#paint7_linear_3905_2713)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3905_2713",
    x: -0.267799,
    y: 15.0491,
    width: 11.509,
    height: 10.6794,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0257453,
    result: "effect1_foregroundBlur_3905_2713"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3905_2713",
    x: 14.5309,
    y: -0.160377,
    width: 10.6715,
    height: 8.52705,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0257453,
    result: "effect1_foregroundBlur_3905_2713"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3905_2713",
    x: 3.45876,
    y: -0.179664,
    width: 11.7014,
    height: 9.4792,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0257453,
    result: "effect1_foregroundBlur_3905_2713"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_3905_2713",
    x: 13.5805,
    y: 15.292,
    width: 16.0357,
    height: 14.9558,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0257453,
    result: "effect1_foregroundBlur_3905_2713"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_3905_2713",
    x: 14.7282,
    y: 11.9468,
    width: 14.9144,
    height: 6.3083,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0257453,
    result: "effect1_foregroundBlur_3905_2713"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_3905_2713",
    x: -0.270729,
    y: 4.72854,
    width: 9.56966,
    height: 11.0273,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0257453,
    result: "effect1_foregroundBlur_3905_2713"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_3905_2713",
    x: 2.45428,
    y: 0.736633,
    width: 9.5686,
    height: 8.29041,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.181,
    result: "effect1_foregroundBlur_3905_2713"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_3905_2713",
    x: 4.13491,
    y: 22.6065,
    width: 10.9154,
    height: 7.66426,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0257453,
    result: "effect1_foregroundBlur_3905_2713"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_3905_2713",
    x: 13.1232,
    y: 23.5818,
    width: 3.75105,
    height: 6.68892,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0257453,
    result: "effect1_foregroundBlur_3905_2713"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3905_2713",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.0525 25.452) rotate(-92.3395) scale(14.9524 21.9632)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.141612,
    stopColor: "#1ABD4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247515,
    stopColor: "#6EC30D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311547,
    stopColor: "#8AC502"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.366013,
    stopColor: "#A2C600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445673,
    stopColor: "#C8C903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.540305,
    stopColor: "#EBCB03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615636,
    stopColor: "#F7CD07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699345,
    stopColor: "#FDCD04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771242,
    stopColor: "#FDCE05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860566,
    stopColor: "#FFCE0A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3905_2713",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(10.3656 -2.54446e-05 -1.45692e-05 13.3866 24.7398 7.99711)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.408458,
    stopColor: "#FB4E5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4540"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3905_2713",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.0793 -2.06593) rotate(151.02) scale(16.6017 22.5283)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.231273,
    stopColor: "#FF4541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311547,
    stopColor: "#FF4540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457516,
    stopColor: "#FF4640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.540305,
    stopColor: "#FF473F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699346,
    stopColor: "#FF5138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771242,
    stopColor: "#FF5B33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860566,
    stopColor: "#FF6C29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8C18"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3905_2713",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.2148 28.2547) rotate(-127.454) scale(43.3096 15.9867)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.131546,
    stopColor: "#0CBA65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.209784,
    stopColor: "#0BB86D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297297,
    stopColor: "#09B479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396257,
    stopColor: "#08AD93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477124,
    stopColor: "#0AA6A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568425,
    stopColor: "#0D9CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667385,
    stopColor: "#1893DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768727,
    stopColor: "#258BF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.858506,
    stopColor: "#3086FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3905_2713",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.7119 2.70519) rotate(96.6178) scale(16.173 22.3619)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.366013,
    stopColor: "#FF4E3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457516,
    stopColor: "#FF8A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.540305,
    stopColor: "#FFA312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615636,
    stopColor: "#FFB60C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771242,
    stopColor: "#FFCD0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860566,
    stopColor: "#FECF0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915033,
    stopColor: "#FECF08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDCD01"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_3905_2713",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.0906 2.53845) rotate(132.119) scale(8.03298 22.6574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.315904,
    stopColor: "#FF4C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.603818,
    stopColor: "#FF692C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726837,
    stopColor: "#FF7825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884534,
    stopColor: "#FF8D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F13"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_3905_2713",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.079 32.0658) rotate(-151.02) scale(16.6017 22.5283)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.231273,
    stopColor: "#0FBC5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311547,
    stopColor: "#0FBC5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.366013,
    stopColor: "#0FBC5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457516,
    stopColor: "#0FBC5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.540305,
    stopColor: "#12BC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699346,
    stopColor: "#28BF3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771242,
    stopColor: "#38C02B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860566,
    stopColor: "#52C218"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915033,
    stopColor: "#67C30F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86C504"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3905_2713",
    x1: 13.1747,
    y1: 26.9262,
    x2: 16.8227,
    y2: 26.9262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FBC5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CBA65"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google-logo.09ab6b27bbeb6a5432e18368b34a315a.svg";
export { ForwardRef as ReactComponent };